'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var winresHeadController = function () {
    function winresHeadController($scope, $window, urlService, localizationService) {
        _classCallCheck(this, winresHeadController);

        this.$scope = $scope;
        this.$window = $window;
        this.urlService = urlService;
        this.localizationService = localizationService;
    }

    _createClass(winresHeadController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().Destination
            // getSeoState()
            // isDepartureUrl()
            //
            this.data = this.winresReservationContext.getContext();

            this.useSeoLinks = this.winresReservationContext.getSeoState();
            this.isDeparture = this.winresReservationContext.isDepartureUrl();

            var url = this.$window.location.href;
            if (this.urlService.isKohdeSivu()) {
                this.urlService.getSeoLinks().then(function (links) {
                    if (links) {
                        _this.updateCanonicalLink(links);
                        _this.updateHreflangLinks(links);
                    }
                });
            } else {
                this.relCan = this.title;
            }

            // Change or add <link rel="canonical"> to <head>

            if (this.urlService.isKohdeSivu()) {
                this.$scope.$watch(function () {
                    return _this.data.Destination;
                }, function () {
                    if (_this.destNameWatch) {
                        // Cancel watch.
                        _this.destNameWatch();
                        _this.destNameWatch = null;
                    }

                    if (_this.data && _this.data.Destination) {
                        _this.destNameWatch = _this.$scope.$watchGroup(['$ctrl.data.Destination.DestinationName', '$ctrl.data.Destination.InternetClassifications', '$ctrl.data.Destination.Headline'], function () {
                            _this.title = _this.getTitle();

                            // Change <head> <title>
                            _this.$window.document.title = _this.title;

                            // Change existing meta description or create new meta description element.
                            _this.updateMetaDescription();
                        }, true);
                    }
                });
            }
        }
    }, {
        key: 'updateCanonicalLink',
        value: function updateCanonicalLink(links) {
            // Change existing canonical href or create new link element
            var canonical = this.$window.document.head.querySelector('[rel="canonical"]') || document.createElement('link');
            canonical.rel = 'canonical';

            var language = this.canonicalLanguage || // Always use this language for canonical href.
            this.localizationService.getLanguage();

            var link = _.find(links, function (l) {
                return l.Language.toLowerCase() === language;
            });
            if (link) {
                canonical.href = link.Link;
            }

            this.$window.document.head.appendChild(canonical);
        }
    }, {
        key: 'updateHreflangLinks',
        value: function updateHreflangLinks(links) {
            _.each(links, function (l) {
                var language = l.Language.toLowerCase();
                var hrefLang = document.head.querySelector('[hreflang="' + language + '"]');
                if (hrefLang) {
                    hrefLang.href = l.Link;
                }
            });
        }
    }, {
        key: 'updateMetaDescription',
        value: function updateMetaDescription() {
            // Change existing meta description or create new meta description element.
            // i = case insensitive.
            var meta = this.$window.document.head.querySelector('meta[name="description" i]') || document.createElement('meta');

            // For new meta.
            meta.name = 'description';

            // Use Headline as content.
            meta.content = this.data && this.data.Destination ? (0, _utils.removeHTMLTags)(this.data.Destination.Headline) : '';

            // Append to head.
            this.$window.document.head.appendChild(meta);
        }
    }, {
        key: 'getTitle',
        value: function getTitle() {
            if (!this.data || !this.data.Destination) {
                return '';
            }

            var title = this.data.Destination.DestinationName;

            if (this.data.Destination.InternetClassifications[0] && this.data.Destination.InternetClassifications[0].Name) title = title + ' - ' + this.data.Destination.InternetClassifications[0].Name;
            if (this.data.Destination.InternetClassifications[1] && this.data.Destination.InternetClassifications[1].Name) title = title + ' - ' + this.data.Destination.InternetClassifications[1].Name;

            return title;
        }
    }]);

    return winresHeadController;
}();

winresHeadController.$inject = ['$scope', '$window', 'urlService', 'localizationService'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl(getWebcomponentsUrl($attrs.templateUrl)) : 'winresHead';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('winresHead', require('./winresHead.html'));
}]);

_module3.default.component('winresHead', {
    templateUrl: getTemplate,
    controller: winresHeadController,
    bindings: {
        //the default title if one is not created from data.
        title: '@',

        // Always use this language code for canonical href. fi, sv, en, de, ru, pl or zh-hans.
        canonicalLanguage: '@'
    },
    require: {
        winresReservationContext: '^^winresReservationContext'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresHead/winresHead.js
// module id = 309
// module chunks = 2